
export const TemplateActionTypes = {
    'SET_TEMPLATE_DATA': 'SET_TEMPLATE_DATA'
  
}